import React, { useEffect, useState, useRef } from "react";
import Breadcrumb from "../../../component/breadcrumb/Breadcrumb";
import Spinner from "../../../component/loadingbar/Spinner";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import Swal from "sweetalert2";
import { triggerNotification } from "../../../component/message/Msg";
import TableViewer from "../../../component/tableViewer/TableViewer";
// import dummyImg from "../../../assetsCon/assets/img/avatars/1.png";
// import ArcProgressChart from "../../../component/chart/arcprogress/ArcProgressChart";
// import DonutChartWithLabel from "../../../component/chart/donut/DonutChartWithLabel";
// import BarChart1 from "../../../component/chart/bar/BarChart1";
// import { useNavigate } from "react-router-dom";
// import { user_type, token } from "../../../config";
// import SimpleLineChart from "../../../component/chart/line/SimpleLineChart";
// import SimpleBubbleChart from "../../../component/chart/bubble/SimpleBubbleChart";
// import SimpleAreaChart from "../../../component/chart/area/SimpleAreaChart";

const SalesHome = () => {
  const token = config.token;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [leadprofiles, setLeadprofiles] = useState([]);
  const [cardData, setCardData] = useState({});

  //  ------For TableViewer ------
  const leadprofilesRef = useRef([]);
  leadprofilesRef.current = leadprofiles;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------
  const handleChangeStatus = async (e, lpid, i) => {
    //  ------For TableViewer ------
    const updatedLeadprofiles = [...leadprofiles];
    updatedLeadprofiles[i] = {
      ...updatedLeadprofiles[i],
      status: e.target.value,
    };
    setLeadprofiles(updatedLeadprofiles);

    const leadprofilesData = updatedLeadprofiles.map((leadprofile) => ({
      name:
        leadprofile.first_name_of_lead + " " + leadprofile.last_name_of_lead,
      email: leadprofile.email_1 + ", " + leadprofile.email_2,
      address:
        leadprofile.city +
        ", " +
        leadprofile.state +
        ", " +
        leadprofile.country,
      source_type: leadprofile.lead_source_type,
      status: leadprofile.status,
      type_of_lead: leadprofile.type_of_lead,
      idNumber: leadprofile.lead_profile_id,
    }));
    setRowData(leadprofilesData);
    //  ------For TableViewer ------

    try {
      await fetch(
        `${config.host_url}lead-profile/status/${lpid}?status=${e.target.value}`,
        {
          method: "GET",
          headers: {
            token: token,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            triggerNotification(
              "success",
              "Lead profile status updated successfully."
            );
            if (e.target.value === "Invoice_generated") {
              console.log("refresh");
              getLeadProfile();
            }
          } else if (data.status === 401) {
            // Invalid Token
            triggerNotification("error", "Unauthenticated User");
          } else {
            // Internal Server Error or other HTTP errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error updating lead profile status");
    }
  };

  //--------------------------------------------------------- get lead-profile leadprofile ---------------------------------------------------------r

  const getLeadProfile = () => {
    setLoading(true);
    fetch(`${config.host_url}lead-profile/my-lead`, {
      method: "GET",
      headers: {
        token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setLeadprofiles(data.data);

          //  ------For TableViewer ------
          const leadprofilesData = data.data.map((leadprofile) => ({
            name:
              leadprofile.first_name_of_lead +
              " " +
              leadprofile.last_name_of_lead,
            email: leadprofile.email_1 + ", " + leadprofile.email_2,
            address:
              leadprofile.city +
              ", " +
              leadprofile.state +
              ", " +
              leadprofile.country,
            source_type: leadprofile.lead_source_type,
            status: leadprofile.status,
            type_of_lead: leadprofile.type_of_lead,
            idNumber: leadprofile.lead_profile_id,
          }));
          setRowData(leadprofilesData);
          //  ------For TableViewer ------
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getCardData = () => {
    setLoading(true);
    fetch(`${config.host_url}sales/home`, {
      method: "GET",
      headers: {
        token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          console.log(data.data);
          setCardData(data.data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getCardData();
    getLeadProfile();
  }, [token]);

  // ---------------------------------------------------- Delete leadprofile ---------------------------------------------------------D
  // Show a confirmation dialog
  const handleDeleteBtn = (deleteId, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete lead profile. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeleteLeadProfile(deleteId, i);
      }
    });
  };

  //If confirm then delete leadprofile
  const handleDeleteLeadProfile = async (deleteId, i) => {
    try {
      await fetch(`${config.host_url}lead-profile/${deleteId}`, {
        method: "DELETE",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            triggerNotification(
              "success",
              "Lead profile deleted successfully."
            );
            //  ------For TableViewer ------
            const updatedleadprofilesStatus = [...leadprofilesRef.current];
            updatedleadprofilesStatus.splice(i, 1);
            setLeadprofiles(updatedleadprofilesStatus);

            const leadprofilesData = updatedleadprofilesStatus.map(
              (leadprofile) => ({
                name:
                  leadprofile.first_name_of_lead +
                  " " +
                  leadprofile.last_name_of_lead,
                email: leadprofile.email_1 + ", " + leadprofile.email_2,
                address:
                  leadprofile.city +
                  ", " +
                  leadprofile.state +
                  ", " +
                  leadprofile.country,
                source_type: leadprofile.lead_source_type,
                status: leadprofile.status,
                type_of_lead: leadprofile.type_of_lead,
                idNumber: leadprofile.lead_profile_id,
              })
            );
            setRowData(leadprofilesData);
            //  ------For TableViewer ------
          } else if (data.status === 401) {
            // Invalid Token
            triggerNotification("error", "Unauthenticated User");
          } else {
            // Internal Server Error or other HTTP errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error deleting lead profile");
    }
  };

  //----------------------------------------------- redir to lead profile detail -------------------------------------------------
  const handleShowBtn = (id) => {
    const encodedId = btoa(encodeURIComponent(id));
    navigate(`/viewleadprofile/${encodedId}`);
  };

  //----------------------------------------------- update / edit employee (redir to add lead profile)  -------------------------------------------------
  const handleEditBtn = (id) => {
    navigate(`/addleadprofile/${btoa(encodeURIComponent(id))}`);
  };

  // const navigate = useNavigate();
  // useEffect(() => {
  //   if (user_type === "admin") {
  //     navigate("/home");
  //   }
  // }, [token]);

  // const [loading, setLoading] = useState(false);

  // const [leadprofiles, setLeadprofiles] = useState([]);

  // const [wonEmployees, setWonEmployees] = useState([
  //   {
  //     img: dummyImg,
  //     employee: "Xon Desturyo",
  //     wonDeal: "760",
  //     demos: "22",
  //   },
  //   {
  //     img: dummyImg,
  //     employee: "Xon Desturyo",
  //     wonDeal: "760",
  //     demos: "22",
  //   },
  //   {
  //     img: dummyImg,
  //     employee: "Xon Desturyo",
  //     wonDeal: "760",
  //     demos: "22",
  //   },
  //   {
  //     img: dummyImg,
  //     employee: "Xon Desturyo",
  //     wonDeal: "760",
  //     demos: "22",
  //   },
  //   {
  //     img: dummyImg,
  //     employee: "Xon Desturyo",
  //     wonDeal: "760",
  //     demos: "22",
  //   },
  //   {
  //     img: dummyImg,
  //     employee: "Xon Desturyo",
  //     wonDeal: "760",
  //     demos: "22",
  //   },
  //   {
  //     img: dummyImg,
  //     employee: "Xon Desturyo",
  //     wonDeal: "760",
  //     demos: "22",
  //   },
  //   {
  //     img: dummyImg,
  //     employee: "Xon Desturyo",
  //     wonDeal: "760",
  //     demos: "22",
  //   },
  //   {
  //     img: dummyImg,
  //     employee: "Xon Desturyo",
  //     wonDeal: "760",
  //     demos: "22",
  //   },
  //   {
  //     img: dummyImg,
  //     employee: "Xon Desturyo",
  //     wonDeal: "760",
  //     demos: "22",
  //   },
  //   {
  //     img: dummyImg,
  //     employee: "Xon Desturyo",
  //     wonDeal: "760",
  //     demos: "22",
  //   },
  //   {
  //     img: dummyImg,
  //     employee: "Xon Desturyo",
  //     wonDeal: "760",
  //     demos: "22",
  //   },
  //   {
  //     img: dummyImg,
  //     employee: "Xon Desturyo",
  //     wonDeal: "760",
  //     demos: "22",
  //   },
  //   {
  //     img: dummyImg,
  //     employee: "Xon Desturyo",
  //     wonDeal: "760",
  //     demos: "22",
  //   },
  // ]);

  // const [salesRepresentatives, setSalesRepresentatives] = useState([
  //   {
  //     imgSrc: dummyImg,
  //     representativeName: "aaa",
  //     amt: "10 Lakh",
  //   },
  //   {
  //     imgSrc: dummyImg,
  //     representativeName: "bbb",
  //     amt: "8 Lakh",
  //   },
  //   {
  //     imgSrc: dummyImg,
  //     representativeName: "ccc",
  //     amt: "6 Lakh",
  //   },
  // ]);

  // const chartData = React.useMemo(
  //   () => [
  //     {
  //       label: "Series 1",
  //       data: [
  //         ["Sunday", 3],
  //         ["Monday", 7],
  //         ["Tuesday", 1],
  //         ["Wednesday", 5],
  //         ["Thursday", 9],
  //         ["Friday", 5],
  //         ["Saturday", 7],
  //       ],
  //     },
  //     {
  //       label: "Series 2",
  //       data: [
  //         ["Sunday", 5],
  //         ["Monday", 8],
  //         ["Tuesday", 3],
  //         ["Wednesday", 5],
  //         ["Thursday", 9],
  //         ["Friday", 3],
  //         ["Saturday", 5],
  //       ],
  //     },
  //   ],
  //   []
  // );

  // // Calculate the minimum value in the data set
  // const minValue = Math.min(
  //   ...chartData.flatMap((series) => series.data.map((point) => point[1]))
  // );

  // // Define the minimum value for the Y-axis
  // const yAxisMin = Math.floor(minValue / 10) * 10; // Round down to nearest multiple of 10

  // // Chart axes
  // const axes = React.useMemo(
  //   () => [
  //     { primary: true, type: "ordinal", position: "bottom" },
  //     { type: "linear", position: "left", min: yAxisMin }, // Set min value of Y-axis
  //   ],
  //   [yAxisMin]
  // );
  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    { field: "name", filter: true },
    { field: "email", filter: true },
    { field: "address", filter: true },
    { field: "source_type", filter: true },
    { field: "type_of_lead", filter: true },
  ];
  //  ------For TableViewer ------
  return (
    // <>
    //   <div className="row flex  justify-around">
    //     {/* c1 */}
    //     <div className="col-lg-7">
    //       <div className="row">
    //         {/* column 1.1 */}
    //         <div className="col-md-5">
    //           <div className="bg-red-300  mb-[16px] rounded bg-white">
    //             <div className=" px-3 pt-1">
    //               <p className="m-0 p-0">Deals Won Value vs Target</p>
    //               <p className="m-0 p-0 text-[#7EA9F8]">Current month</p>
    //             </div>
    //             <div className="pb-0 mb-0 flex justify-center pt-3">
    //               <ArcProgressChart
    //                 progress="0.9"
    //                 achieved="9 lakh"
    //                 target="10 lakh"
    //               />
    //             </div>
    //           </div>
    //           <div className="bg-red-300 px-3 py-1  mb-[16px] rounded bg-white">
    //             <p className="m-0 p-0">New Revenue</p>
    //             <p className="m-0 p-0 text-[#7EA9F8]">Current month</p>
    //             <p className="font-bold  pt-2 pb-1 text-[#3782CE] text-center">
    //               10 Lakh
    //             </p>
    //           </div>
    //           <div className="bg-red-300 px-3 pt-1  mb-[16px] rounded bg-white">
    //             <p className="m-0 p-0">Upcoming Demos</p>
    //             <p className="m-0 p-0 text-[#7EA9F8]">Current month</p>
    //             <DonutChartWithLabel />
    //           </div>
    //         </div>
    //         {/* column 1.2 */}
    //         <div className="col-lg-7">
    //           <div className="bg-red-300 px-3 pt-1  mb-[16px] rounded bg-white">
    //             <p className="m-0 p-0">New Revenue by sales Representative</p>
    //             <p className="m-0 p-0 text-[#7EA9F8]">Current month</p>
    //             <div className="row p-3">
    //               {salesRepresentatives.map((salesRepresentative, i) => (
    //                 <div key={i} className="col-md-4 ">
    //                   <div className="relative">
    //                     <img
    //                       src={salesRepresentative.imgSrc}
    //                       className="rounded-full pull-up border-2 border-[#196CB7] w-28"
    //                       alt=""
    //                     />
    //                     <div
    //                       className="absolute bottom-0 left-0 w-full flex justify-center"
    //                       style={{ marginBottom: "-10%" }}
    //                     >
    //                       <div className="w-4 h-4 text-xs bg-[#196CB7] text-white rounded-full  text-center">
    //                         {i + 1}
    //                       </div>
    //                     </div>
    //                   </div>

    //                   <p className="p-0 m-0 font-bold mt-2 text-[#3782CE] text-center">
    //                     {salesRepresentative.representativeName}
    //                   </p>
    //                   <p className="text-center ">{salesRepresentative.amt}</p>
    //                 </div>
    //               ))}
    //             </div>
    //           </div>
    //           <div className="bg-red-300 px-3 pt-1  mb-[16px] rounded bg-white">
    //             <p className="m-0 p-0">Current Month</p>
    //             <div className="table-responsive text-nowrap mt-2 ">
    //               <table className="table table-striped table-sm">
    //                 <thead>
    //                   <tr>
    //                     <th className="text-xs " style={{ color: "#498DD2" }}>
    //                       EMPLOYEE
    //                     </th>
    //                     <th className="text-xs " style={{ color: "#498DD2" }}>
    //                       WON DEALS
    //                     </th>
    //                     <th className="text-xs " style={{ color: "#498DD2" }}>
    //                       DEMOS
    //                     </th>
    //                   </tr>
    //                 </thead>
    //                 <tbody className="table-border-bottom-0">
    //                   {wonEmployees?.map((wonEmployee, i) => (
    //                     <tr key={i}>
    //                       <td className="flex text-xs ">
    //                         <img
    //                           className="avatar avatar-xs pull-up rounded-circle"
    //                           src={wonEmployee.img}
    //                           alt="employee"
    //                         ></img>
    //                         <span className="fw-medium ml-2 self-center">
    //                           {wonEmployee.employee}
    //                         </span>
    //                       </td>
    //                       <td className=" text-xs ">{wonEmployee.wonDeal}</td>
    //                       <td className=" text-xs ">{wonEmployee.demos}</td>
    //                     </tr>
    //                   ))}
    //                 </tbody>
    //               </table>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //       <div className="row">
    //         <div className="col-md-4">
    //           <button
    //             type="button"
    //             className="btn btn-primary p-2  w-full "
    //             onClick={() => {
    //               navigate("/addemployee");
    //             }}
    //           >
    //             Add Staff
    //           </button>
    //         </div>
    //         <div className="col-md-4">
    //           <button
    //             type="button"
    //             className="btn btn-primary p-2 w-full"
    //             onClick={() => {
    //               navigate("/addleadprofile");
    //             }}
    //           >
    //             Create Regions
    //           </button>
    //         </div>
    //         <div className="col-md-4">
    //           <button
    //             type="button"
    //             className="btn btn-primary p-2 w-full"
    //             onClick={() => {
    //               navigate("/addrefferal");
    //             }}
    //           >
    //             Create Discount
    //           </button>
    //         </div>
    //       </div>
    //     </div>
    //     {/* c2 */}
    //     <div className="col-md-5 ">
    //       <div className="row">
    //         {/* column 3.1 */}
    //         <div className="col-md-6 ">
    //           <div className="bg-red-300 px-3 py-1  mb-[16px] rounded bg-white">
    //             <p className="m-0 p-0">Monthly Subscription</p>
    //             <p className="m-0 p-0 text-[#7EA9F8]">Current month</p>
    //             <p className="text-4xl py-8 text-black font-medium  text-center">
    //               49%
    //             </p>
    //           </div>
    //           <div className="bg-red-300 px-3 py-1  mb-[16px] rounded bg-white">
    //             <p className="m-0 p-0">2 Year Subscription</p>
    //             <p className="m-0 p-0 text-[#7EA9F8]">Current month</p>
    //             <p className="text-4xl py-8 text-black font-medium  text-center">
    //               41%
    //             </p>
    //           </div>
    //         </div>
    //         {/* column 3.2 */}
    //         <div className="col-md-6 ">
    //           <div className="bg-red-300 px-3 py-1  mb-[16px] rounded bg-white">
    //             <p className="m-0 p-0">Yearly Subscription</p>
    //             <p className="m-0 p-0 text-[#7EA9F8]">Current month</p>
    //             <p className="text-4xl py-8 text-black font-medium  text-center">
    //               73%
    //             </p>
    //           </div>
    //           <div className="bg-red-300 px-3 py-1  mb-[16px] rounded bg-white">
    //             <p className="m-0 p-0"> New Customer</p>
    //             <p className="m-0 p-0 text-[#7EA9F8]">Current month</p>
    //             <p className="text-4xl py-8 text-black font-medium  text-center">
    //               134
    //             </p>
    //           </div>
    //         </div>
    //       </div>
    //       <div className="row">
    //         <BarChart1 data={chartData} />
    //         {/* <SimpleLineChart />
    //         <SimpleBubbleChart />
    //         <SimpleAreaChart /> */}
    //       </div>
    //     </div>
    //   </div>
    // </>
    <>
      <Breadcrumb txt="Home" subpath={["Dashboard"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex ">
            <h5 className="mb-0">Dashboard</h5>
          </div>

          {/* four cards */}
          <div className="flex justify-between px-4 py-2 row">
            <div className="col-sm-3 ">
              <div className="card">
                <div className="card-body">
                  <h5>{cardData.myTotalCoupons} </h5>
                  <p className="mb-lg-2 mb-xl-3">My Total Coupons</p>
                </div>
              </div>
            </div>
            <div className="col-sm-3 ">
              <div className="card">
                <div className="card-body">
                  <h5>{cardData.totalUsedCoupons}</h5>
                  <p className="mb-lg-2 mb-xl-3">Total Used Coupons</p>
                </div>
              </div>
            </div>
            <div className="col-sm-3 ">
              <div className="card">
                <div className="card-body">
                  <h5>{cardData.totalLeads} </h5>
                  <p className="mb-lg-2 mb-xl-3">Total Leads</p>
                </div>
              </div>
            </div>
            <div className="col-sm-3 ">
              <div className="card">
                <div className="card-body">
                  <h5>{cardData.totalCompletedLeads}</h5>
                  <p className="mb-lg-2 mb-xl-3"> Total Completed Leads</p>
                </div>
              </div>
            </div>
          </div>
          <hr className="mx-4 mt-6 mb-0" />
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0 ">My Lead Profiles</h5>
            <div>
              <button
                type="button"
                className="btn btn-primary ml-4"
                onClick={() => {
                  navigate("/addleadprofile");
                }}
              >
                Add Lead Profile
              </button>
            </div>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3 row mx-4  table-responsive">
              {/* ------For TableViewer ------ */}
              <TableViewer
                rowData={rowData}
                colDefs={colDefs}
                onEdit={handleEditBtn}
                onDelete={handleDeleteBtn}
                onView={handleShowBtn}
                onStatusChange={handleChangeStatus}
              />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SalesHome;
